import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import Toast from 'components/common_v2/toasts';
import { getAlertBannerContent } from './helpers';

export const AlertBanners = ({
  user
}) => {
  const alertBannerContent = isEmpty(user) ? null : getAlertBannerContent(user);

  if (alertBannerContent) {
    return (
      <div style={{ marginBottom: '8px' }}>
        <Toast
          {...alertBannerContent}
        />
      </div>
    );
  }

  return null;
};

AlertBanners.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    customer: PropTypes.object
  }).isRequired
};
